// @flow

import * as React from 'react';

import clsx from 'clsx';
import { ShoppingCart, Check, X } from 'lucide-react';

import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';

import { useDelayedProps } from 'src/hooks/useDelayedProps';

import styles from './CartButton.scss';

type Props = {
  addedToCart?: boolean,
  loading?: boolean,
  isCartActionnable?: boolean,
  onClick: (evt: SyntheticMouseEvent<>) => Promise<void> | mixed,
};

export function CartButton({
  addedToCart,
  loading,
  isCartActionnable,
  onClick,
}: Props): React.MixedElement | null {
  const { __ } = useTranslator();

  const added = addedToCart && !loading;

  const { label, Icon, intent } = useDelayedProps(
    { label: __('Added'), Icon: Check, intent: 'success' },
    { label: __('Remove'), Icon: X, intent: undefined },
    added,
  );

  const CurrentIcon = added ? Icon : ShoppingCart;
  const currentLabel = added ? label : __('Add to cart');

  const props = {
    onClick,
    disabled: !isCartActionnable,
    intent: added ? intent : undefined,
    loading,
  };

  if (!isCartActionnable && !loading && !addedToCart) {
    return null;
  }

  return (
    <Button
      className={clsx(styles.button, styles.layout)}
      {...props}
      title={currentLabel}
    >
      {addedToCart && <CurrentIcon size={16} />}
      {currentLabel}
    </Button>
  );
}
